import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel/InputLabel';
import Select from '@material-ui/core/Select/Select';
import Input from '@material-ui/core/Input/Input';
import Checkbox from '@material-ui/core/Checkbox/Checkbox';
import ListItemText from '@material-ui/core/ListItemText/ListItemText';
import KobooButton from '../Layout/KobooButton';
import * as routes from '../../constants/routes';
import { getRenters } from '../../store/renters/actions';
import Spinner from '../Layout/Spinner';
import { getSites } from '../../store/sites/actions';
import defaultStyles from '../../constants/stylesDefault';
import Loader from '../Layout/Loader';
import KobooTextField from '../Layout/KobooTextField.jsx';
import withAuthorization from '../../hoc/withAuthorization';
import { getVouchers, putVoucher } from '../../store/vouchers/actions';
import StringService from "../../services/StringService";

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  }
});

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

const filteredVoucherSites  = (sites, voucherSites) => {
  let filteredVoucherSites = [];
  sites.forEach((site) => {
    if (voucherSites.find(voucherSite => voucherSite.id === site.id)) {
      filteredVoucherSites.push(site);
    }
  });
  return filteredVoucherSites;
};

const getStateByVoucherInfo = (voucher, sites) => ({
  selectedSites: voucher.sites ? filteredVoucherSites(sites, voucher.sites) : [],
  renter_id: voucher.renter_info ? voucher.renter_info.id : '',
  sites: voucher.renter_info
    ? sites.filter(site => site.renter_info_id === voucher.renter_info.id) : [],
  type: voucher.type ? voucher.type : 0,
  value: voucher.value ? voucher.value / 100 : null,
  percent: voucher.percent ? voucher.percent : null,
  endDate: voucher.end_date ? StringService.dateTimestampToString(voucher.end_date)
    : StringService.dateTimestampToString(Date.now() / 1000),
});

const INITIAL_STATE = {
  voucher_id: '',
  sites: [],
  selectedSites: [],
  renter_id: '',
  type: 0,
  value: null,
  percent: null,
  endDate: StringService.dateTimestampToString(Date.now() / 1000)
};

const types = ["Usage unique", "Abonnement", "Usage Multiple"];

export class EditVouchersForm extends Component {
  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE, voucher_id: this.props.match.params.voucherId };
  }

  static propTypes = {
    authUser: PropTypes.object,
    classes: PropTypes.object.isRequired,
  };

  static getDerivedStateFromProps(props, state) {
    let newState = null;
    if (
      props.authUser
      && props.roles
      && props.errorSites === null
      && props.errorRenters === null
      && props.errorVouchers === null
    ) {
      const role = props.roles[props.authUser.uid];
      newState = { ...newState, role };
      if (!props.vouchers && !props.pendingVouchers) {
        props.getVouchers(props.authUser.ma, role);
      }
      if (!props.renters && !props.pendingRenters) {
        props.getRenters(props.authUser.ma, role);
      }
      if (!props.sites && !props.pendingSites) {
        props.getSites(props.authUser.ma, role);
      }
    }

    if (props.vouchers && state.renter_id === INITIAL_STATE.renter_id && props.sites) {
      const foundVoucher = props.vouchers.find(voucher => voucher.id === state.voucher_id);
      if (foundVoucher) {
        newState = {...newState, ...getStateByVoucherInfo(foundVoucher, props.sites)};
      }
    }
    return newState;
  }

  onSubmit = (event) => {
    const {
      type,
      value,
      percent,
      endDate,
      renter_id,
      selectedSites
    } = this.state;
    this.props.putVoucher(
      this.props.authUser.ma,
      this.state.voucher_id,
      {
        renter_id,
        sites: selectedSites,
        type,
        value: value * 100,
        percent,
        end_date: StringService.dateStringToTimestamp(endDate)
      },
    ).then((value) => {
      if (value) {
        this.props.history.push(routes.VOUCHERS);
      }
    });

    event.preventDefault();
  };

  onSelectRenter = (event) => {
    this.setState(byPropKey('renter_id', event.target.value));
    const foundRenter = this.props.renters.find(renter => renter.id === event.target.value);
    this.setState(byPropKey(
      'sites',
      this.props.sites.filter(site => site.renter_info_id === foundRenter.id),
    ));
  };

  onSelectSite = (event) => {
    this.setState(byPropKey('selectedSites', event.target.value));
  };

  render() {
    const {
      renter_id,
      type,
      value,
      percent,
      endDate,
      sites,
      selectedSites
    } = this.state;

    const { classes, renters, pending } = this.props;
    if (pending) {
      return (<Loader />);
    } else if (renters && renters.length) {
      return (
        <form
          onSubmit={this.onSubmit}
          style={defaultStyles.center}
          className={classes.container}
        >
          <TextField
            id="renter_id"
            type="text"
            select
            label="Loueur"
            className={classes.textField}
            value={renter_id}
            onChange={this.onSelectRenter}
            helperText="Choisissez le loueur"
            margin="normal"
          >
            {renters.map(renter => (
              <MenuItem key={renter.id} value={renter.id}>
                {renter.name}
              </MenuItem>
            ))}
          </TextField>
          <InputLabel htmlFor="select-multiple">Sites</InputLabel>
          <Select
            className={classes.textField}
            multiple
            value={selectedSites}
            renderValue={selected => {
              let sites = "";
              selected.forEach((site) => {
                sites += site.name + ', ';
              });
              return sites;
            }}
            onChange={this.onSelectSite}
            input={<Input id="select-multiple" />}
          >
            {sites.map(site => (
              <MenuItem key={site.id} value={site}>
                <Checkbox checked={selectedSites
                  .find(selectedSite => selectedSite.id === site.id)} />
                <ListItemText primary={site.name} />
              </MenuItem>
            ))}
          </Select>
          <TextField
            id="type"
            type="text"
            select
            label="Type"
            className={classes.textField}
            value={type}
            onChange={event => this.setState(byPropKey('type', event.target.value))}
            helperText="Choisissez le type"
            margin="normal"
          >
            {types.map((type, index) => (
              <MenuItem key={index} value={index}>
                {type}
              </MenuItem>
            ))}
          </TextField>
          {type === 0 &&
          < KobooTextField
            label="Valeur (en euros)"
            id="value"
            type="number"
            onChange={event => this.setState(byPropKey('value', event.target.value))}
            value={value}
          />
          }
          {type !== 0 &&
          < KobooTextField
            label="Réduction (en %)"
            id="percent"
            type="number"
            onChange={event => this.setState(byPropKey('percent', event.target.value))}
            value={percent}
          />
          }
          {type !== 0 &&
          < KobooTextField
            label="Fin de validité"
            id="endDate"
            type="date"
            onChange={event => this.setState(byPropKey('endDate', event.target.value))}
            value={endDate}
          />
          }
          <KobooButton disabled={this.props.sending} type="submit">
            {this.props.sending ?
              <Spinner style={{ parent: { margin: '4px auto 0' }, child: {} }}/> : 'Editer'}
          </KobooButton>
        </form>
      );
    }
    return (
      <Typography variant="subtitle1">
        Aucun loueur n'a été créé, veuillez en créer un <Link to={routes.RENTER_ADD}>ici</Link>.
      </Typography>);
  }
}

function mapStateToProps(state) {
  return {
    authUser: state.users.authUser,
    renters: state.renters.content,
    vouchers: state.vouchers.content,
    sites: state.sites.content,
    pending: state.renters.pending || state.sites.pending || state.vouchers.pending,
    sending: state.bikes.sending,
    pendingRenters: state.renters.pending,
    pendingSites: state.sites.pending,
    pendingVouchers: state.vouchers.pending,
    errorSites: state.sites.error,
    errorRenters: state.renters.error,
    errorVouchers: state.vouchers.error
  };
}

export default compose(
  withAuthorization(authUser => !!authUser),
  withStyles(styles),
  connect(mapStateToProps, { putVoucher, getRenters, getSites, getVouchers }),
)(EditVouchersForm);



// WEBPACK FOOTER //
// ./src/components/Voucher/EditVouchersForm.jsx